__turbopack_context__.v({
  "fieldError": "detail-section-module-scss-module__51zDKG__fieldError",
  "infoIconButton": "detail-section-module-scss-module__51zDKG__infoIconButton",
  "panel": "detail-section-module-scss-module__51zDKG__panel",
  "panelDivider": "detail-section-module-scss-module__51zDKG__panelDivider",
  "panelRow": "detail-section-module-scss-module__51zDKG__panelRow",
  "panelRowLabel": "detail-section-module-scss-module__51zDKG__panelRowLabel",
  "panelRowLabelText": "detail-section-module-scss-module__51zDKG__panelRowLabelText",
  "panelRowValue": "detail-section-module-scss-module__51zDKG__panelRowValue",
  "resetLink": "detail-section-module-scss-module__51zDKG__resetLink",
  "section": "detail-section-module-scss-module__51zDKG__section",
  "sectionHeader": "detail-section-module-scss-module__51zDKG__sectionHeader",
  "sectionLabel": "detail-section-module-scss-module__51zDKG__sectionLabel",
  "sections": "detail-section-module-scss-module__51zDKG__sections",
});
